import axios from 'axios';

class LogClient {
    static sendLogToServer(log, furtherInformation) {
        return axios.put('/api/log', { log: log, furtherInformation: furtherInformation });
    }
}

export default LogClient;
